// Import model
import { ProjectAppointmentCondition } from '../models/ProjectAppointmentCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ProjectAppointmentIndexedFields } from '../models/ProjectAppointmentIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ProjectAppointmentIndexedFieldsSerializer } from './ProjectAppointmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProjectAppointmentCondition - handles JSON serialization and deserialization with type validation
 */
export class ProjectAppointmentConditionSerializer {
  /**
   * Deserializes a JSON string into a ProjectAppointmentCondition instance
   */
  static deserialize(json: string): ProjectAppointmentCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProjectAppointmentCondition instance
   */
  static fromObject(obj: any): ProjectAppointmentCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProjectAppointmentCondition');
    }


    const instance: ProjectAppointmentCondition = {
      fieldName: obj['fieldName'] as ProjectAppointmentIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProjectAppointmentCondition instances
   */
  static deserializeArray(json: string): ProjectAppointmentCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProjectAppointmentCondition instance to a JSON string
   */
  static serialize(instance: ProjectAppointmentCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProjectAppointmentCondition instance to a plain object
   */
  static toObject(instance: ProjectAppointmentCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ProjectAppointmentCondition instances to a JSON string
   */
  static serializeArray(instances: ProjectAppointmentCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
